import React from "react";

import { Button } from "../../../components/Field";
import Product from "./Product";
import Title from "../../../components/Title";
import Spacer from "../../../components/Spacer";
import Section from "../../../components/Section";
import ContentGrid from "../../../components/ContentGrid";

import style from "./style.module.css";

export default function ProductGrid(props) {
    const {
        url = "",
        title = "",
        product = [],
        delay = 5000,
        sub_title = "",
        autoplay = false,
        button_label = "",
        wrap_products = 0,
        enlarge_title = ""
    } = props;

    const subTitle = enlarge_title === 1 ? "h5" : "h6"
    const headTitle = enlarge_title === 1 ? "h1" : "h3"

    return (
        <Section className={style.merchandisePage}>
            <div className={style.merchandisePageHeader}>
                <Spacer size="65" />
                <div className={`${style.merchandisePageTitles}`}>
                    {
                        sub_title !== "" && (
                            <Title tag={subTitle} className="fontTeko">{sub_title}</Title>
                        )
                    }
                    {
                        title !== "" && (
                            <Title tag={headTitle} transform="uppercase" className="fontTeko">{title}</Title>
                        )
                    }
                    <Spacer size="32" />
                </div>
                {
                    product.length > 0 && (
                        <ContentGrid 
                            wrap={wrap_products} 
                            items={product} 
                            Component={Product} 
                            autoplay={autoplay}
                            delay={delay} 
                            col={wrap_products === 1 ? "col5" : "col1"}
                        />
                    )
                }
                {
                    button_label !== "" && url !== "" && (
                        <div className={style.merchandiseButton}>
                            <Spacer size="32" />
                            <Button size="buttonBig" color="buttonPrimaryWithOutBg" label={button_label} link={url} />
                        </div>
                    )
                }
            </div>
        </Section>
    )
}